// this is an autogenerated file from App/Account/Content/Settings/Content/CommsEmail/Emails/Emails/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_CommsEmail_Emails_Emails($location_id: uuid!) {
  emails: comms_outbound_emails(order_by: { created_at: desc }) {
    id
    name
    email
    updated_at
    updated_by_user {
      id
      vaxiom_person {
        id
        first_name
        last_name
      }
    }
  }
  defaults: comms_defaults(
    where: { location_id: { _eq: $location_id }, type: { _eq: "email" } }
  ) {
    id
    sender_id
    updated_at
    updated_by_user {
      id
      vaxiom_person {
        id
        first_name
        last_name
      }
    }
  }
}

`